import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ModalToCreateClusters from "../../ModalToCreateClusters";
import AddJobDialog from "../../recce/addJobModal.jsx";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  Tooltip,
  Menu,
  MenuItem,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../JobBatch.module.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";

const AvailableBatches = ({
  openModalToCreateJobClusters,
  setOpenModalToCreateJobClusters,
  selectAllBatches,
  availableBatches,
  setAvailableBatches,
  selectedBatches,
  setSelectAllBatches,
  setSelectedBatches,
  campaignData,
  soDetails,
  productDetails,
  categoryData,
}) => {
  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [allBatchesLoading, setAllBatchesLoading] = useState(false);
  const [menuPosition, setMenuPosition] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [openAddJob, setOpenAddJob] = useState(false);

  const [error, setError] = useState(null);

  const handleMenuClick = (event, job) => {
    event.stopPropagation();

    setSelectedJob(job);

    setMenuPosition({
      top: event.clientY,
      left: event.clientX,
    });
  };

  const handleCloseMenu = () => {
    setMenuPosition(null);
  };

  const handleAddJob = () => {
    setOpenAddJob(true);
    handleCloseMenu();
  };

  const calculateTotalJobs = () => {
    return availableBatches?.reduce(
      (total, batch) => total + (batch.jobs?.length || 0),
      0,
    );
  };
  const calculateTotalBatches = () => {
    return availableBatches?.length || 0;
  };
  const handleSelectBatch = (batch) => {
    setSelectedBatches((prevSelected) => {
      const isAlreadySelected = prevSelected.some((b) => b._id === batch._id);

      if (isAlreadySelected) {
        // Remove the batch if it's already selected
        return prevSelected.filter((b) => b._id !== batch._id);
      } else {
        // Otherwise, add the batch
        return [...prevSelected, batch];
      }
    });
  };

  const handleSelectAllBatches = (e) => {
    if (e.target.checked) {
      setSelectedBatches(availableBatches); // Store the full batch objects
      setSelectAllBatches(true);
    } else {
      setSelectedBatches([]);
      setSelectAllBatches(false);
    }
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const { id } = useParams();
  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };

  React.useEffect(() => {
    if (id) {
      fetchAllJobsBasedOnCampaignId(id);
    }
  }, [id]);

  const fetchAllJobsBasedOnCampaignId = async (id) => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/jobs/getAllJobs?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        // setAvailableJobs(response.data.data);
        fetchAllBatchesBasedOnCampaignId(response.data.data, id);
      }
    } catch (error) {
      console.error("error in while fetching jobs", error);
      setError("Failed to fetch jobs. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchAllBatchesBasedOnCampaignId = async (jobs, id) => {
    setAllBatchesLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/batchOfJobs/getAllBatchesForVendor?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        const updatedBatches = response?.data?.data.map((batch) => ({
          ...batch,
          jobs: [],
        }));

        // Only add jobs that are approved by client and active
        jobs?.forEach((job) => {
          const isApproved = job.jobApprovalStatus?.clientStatus === 1;
          const isActive = job.status !== 0;

          if (
            (isApproved && isActive) ||
            !campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce")
          ) {
            const batch = updatedBatches.find(
              (batch) => batch._id === job.batchOfJobsForVendorId,
            );
            if (batch) {
              batch.jobs.push(job);
            }
          }
        });
        const filteredBatches = updatedBatches.filter((batch) => {
          if (campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce")) {
            return (
              !batch.idOfClusterOfBatchesForVendor &&
              batch.jobs.some((job) => job.status !== 0)
            );
          }
          return !batch.idOfClusterOfBatchesForVendor;
        });
        setAvailableBatches(filteredBatches);
        setAllBatchesLoading(false);

        // setAvailableBatches(updatedBatches);
      }
    } catch (error) {
      setAllBatchesLoading(false);

      console.error("error in while fetching batches", error);
      setError("Failed to fetch batches. Please try again.");
    }
  };

  const DataRow = ({ row, handleMenuClick }) => (
    <TableRow className={styles.customRow}>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>{row?.address}</div>
        <div className={styles.address2}>{row?.city}</div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>{row?.storeOwnerName}</div>
        <div className={styles.storeManagerContact}>
          {row?.storeOwnerPhoneNumber}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {`${row?.product?.approvedWidth || row?.product?.productWidth} * ${
            row?.product?.approvedHeight || row?.product?.productHeight
          } * 
    
    ${row?.product?.productThickness ?? "N/A"}`}
        </div>
      </TableCell>

      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.product?.productType || "N/A"}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <Tooltip
          title={
            row?.installationPartnerId
              ? "Recce as a service selected"
              : "Actions"
          }
        >
          <span style={{ display: "inline-block" }}>
            <IconButton
              disabled={!!row?.installationPartnerId}
              onClick={(event) => {
                event.stopPropagation();
                handleMenuClick(event, row);
              }}
            >
              <MoreVertIcon />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );

  if (loading) {
    return (
      <div className={styles.noJobsStyle}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <>
      <Grid className={`${styles.scrollableContainer}`}>
        {allBatchesLoading ? (
          <div className="flex justify-center items-center h-40">
            <CircularProgress />
          </div>
        ) : availableBatches.length > 0 ? (
          <>
            {/* Select All Batches Checkbox and Chips */}
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "space-between", // Keep checkbox on the left and chips on the right
                alignItems: "center", // Align vertically
                marginBottom: 2,
                marginRight: 3,
                marginLeft: 3,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      selectedBatches?.length === availableBatches?.length
                    }
                    indeterminate={
                      selectedBatches?.length > 0 &&
                      selectedBatches?.length < availableBatches.length
                    }
                    onChange={handleSelectAllBatches}
                  />
                }
                label="Select All Batches"
              />
              <div style={{ display: "flex", gap: "12px" }}>
                <Chip
                  label={`Total Batches: ${calculateTotalBatches()}`}
                  className={styles.totalBatchesChip}
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: "400",
                    padding: "6px 12px",
                    backgroundColor: "transparent",
                    border: "1px solid #d9dadb",
                    color: "black",
                  }}
                />
                <Chip
                  label={`Total Jobs: ${calculateTotalJobs()}`}
                  className={styles.totalJobsChip}
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: "400",
                    padding: "6px 12px",
                    backgroundColor: "transparent",
                    border: "1px solid #d9dadb",
                    color: "black",
                  }}
                />
              </div>
            </Grid>

            {availableBatches?.map((batch, index) => (
              <Grid item xs={12} md={12} key={index}>
                <Accordion expanded={expandedBatch === batch.batchTitle}>
                  <AccordionSummary
                    expandIcon={
                      <IconButton
                        onClick={handleAccordionToggle(batch.batchTitle)}
                      >
                        <ExpandMoreIcon />
                      </IconButton>
                    }
                    aria-controls={`panel-${index}-content`}
                    id={`panel-${index}-header`}
                    className={styles.accordionHeader}
                  >
                    <Checkbox
                      checked={selectedBatches?.some(
                        (b) => b?._id === batch?._id,
                      )}
                      onChange={() => handleSelectBatch(batch)}
                      onClick={(e) => e.stopPropagation()} // still needed to prevent accordion open
                    />
                    <div className={styles.batchHeader}>
                      <h1 className={styles.batchTitle}>{batch.batchTitle}</h1>
                      <div className={styles.chipContainer}>
                        <Chip
                          label={`Allotted Timeline : ${moment(
                            batch?.jobStartingDate,
                          ).format("DD MMM YY")}- ${moment(
                            batch?.jobCompletionDate,
                          ).format("DD MMM YY")}`}
                          className={styles.chip}
                        />
                        <Chip
                          label={`Jobs: ${batch.jobs?.length || 0}`}
                          className={styles.chip}
                        />
                      </div>
                    </div>
                  </AccordionSummary>

                  <AccordionDetails className={styles.accordionDetails}>
                    <Box className={`${styles.scrollableBox}`}>
                      <TableContainer
                        component={Paper}
                        className={styles.tableContainer}
                      >
                        <Table className={styles.table}>
                          <TableHead>
                            <TableRow className={styles.tableHeader}>
                              <TableCell className={styles.tableCell}>
                                DELIVERY ADDRESS
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                STORE MANAGER
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                DIMENSIONS (W×H×T)
                              </TableCell>
                              {/* <TableCell className={styles.tableCell}>
                                BASE MATERIAL
                              </TableCell> */}
                              <TableCell className={styles.tableCell}>
                                PRODUCT TYPE
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                ACTION
                              </TableCell>
                              {/* <TableCell className={styles.tableCell}>
                                    PRINT DETAILS
                                  </TableCell> */}
                              {/* <TableCell className={styles.tableCell}>
                                PRINT IMAGE
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                CAD FILE
                              </TableCell> */}
                              {/* <TableCell className={styles.tableCell}>
                                  OEM PREFERENCE
                                </TableCell> */}
                              {/* <TableCell className={styles.tableCell}>
                                    DESCRIPTION
                                  </TableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {batch.jobs
                              ?.filter((job) => {
                                if (
                                  campaignData?.scopeOfWork?.servicesNeeded?.includes(
                                    "Recce",
                                  )
                                ) {
                                  return (
                                    job.jobApprovalStatus?.clientStatus === 1
                                  );
                                }
                                return true;
                              })
                              ?.map((row, index) => (
                                <DataRow
                                  key={index}
                                  row={row}
                                  handleMenuClick={handleMenuClick}
                                />
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}
          </>
        ) : (
          <div className={styles.noJobsStyle}>
            <Box className={styles.noJobsBox}>
              <p className={styles.noJobsText}>
                {availableBatches.length === 0 && !loading && !error
                  ? "No batches available with client-approved jobs"
                  : "No batches available"}
              </p>
            </Box>
          </div>
        )}
      </Grid>

      <Menu
        open={Boolean(menuPosition)}
        onClose={() => setMenuPosition(null)}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition}
      >
        <MenuItem onClick={handleAddJob}>Duplicate Job</MenuItem>
      </Menu>

      {openModalToCreateJobClusters && (
        <ModalToCreateClusters
          selectedBatches={selectedBatches}
          openModalToCreateJobClusters={openModalToCreateJobClusters}
          setOpenModalToCreateJobClusters={setOpenModalToCreateJobClusters}
          campaignData={id}
          productCategory={campaignData.scopeOfWork}
          setSelectedBatches={setSelectedBatches}
          availableBatches={availableBatches}
          fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
          setSnackbar={setSnackbar}
          // servicesNeeded={campaignData?.scopeOfWork?.servicesNeeded}
        />
      )}

      {openAddJob && (
        <AddJobDialog
          open={openAddJob}
          onClose={() => setOpenAddJob(false)}
          campaignId={id}
          selectedJob={selectedJob}
          soDetails={soDetails}
          categoryData={categoryData}
          productDetails={productDetails}
          fetchAllBatchesBasedOnCampaignId={(id) =>
            fetchAllJobsBasedOnCampaignId(id)
          }
          fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
          createJobFrom={"batches"}
          setAnchorEl={setMenuPosition}
          jobForWhichService="Painting"
        />
      )}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Positioned on the left side
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          icon={
            snackbar.severity === "success" ? (
              <CheckCircleIcon sx={{ color: "white" }} />
            ) : (
              <ErrorIcon sx={{ color: "white" }} />
            )
          }
          sx={{
            backgroundColor: snackbar.severity === "success" ? "green" : "red",
            color: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AvailableBatches;
